import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LocaleDTO } from "@shared/models/locale-dto";
import { environment } from "@env";

@Injectable({
  providedIn: "root"
})
export class LocaleService {
  private localeUrl = "locales/";

  constructor(private http: HttpClient) {}

  listAll(): Observable<LocaleDTO[]> {
    return this.http.get<LocaleDTO[]>(environment.apiUrl + this.localeUrl);
  }
}
